import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import Warning from "../../assets/images/warningalert.svg";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { notifyError, notifySuccess } from "../../toaster/notify";
import { json, Link } from "react-router-dom";
import { useToast } from "react-toastify";

function CalendarSettings() {
  const OffDays = [
    {
      OffDay: "Monday",
      WorkDayType: 0,
      Week1: false,
      Week2: false,
      Week3: false,
      Week4: false,
      Week5: false,
      week6: false,
    },
    {
      OffDay: "Tuesday",
      WorkDayType: 0,
      Week1: false,
      Week2: false,
      Week3: false,
      Week4: false,
      Week5: false,
      week6: false,
    },
    {
      OffDay: "Wednesday",
      WorkDayType: 0,
      Week1: false,
      Week2: false,
      Week3: false,
      Week4: false,
      Week5: false,
      week6: false,
    },
    {
      OffDay: "Thursday",
      WorkDayType: 0,
      Week1: false,
      Week2: false,
      Week3: false,
      Week4: false,
      Week5: false,
      week6: false,
    },
    {
      OffDay: "Friday",
      WorkDayType: 0,
      Week1: false,
      Week2: false,
      Week3: false,
      Week4: false,
      Week5: false,
      week6: false,
    },
    {
      OffDay: "Saturday",
      WorkDayType: 0,
      Week1: false,
      Week2: false,
      Week3: false,
      Week4: false,
      Week5: false,
      week6: false,
    },
    {
      OffDay: "Sunday",
      WorkDayType: 0,
      Week1: false,
      Week2: false,
      Week3: false,
      Week4: false,
      Week5: false,
      week6: false,
    },
  ];

  const [roles, setRoles] = useState([]);

  const [update, setUpdate] = useState(true);

  const [isvalitaded, setIsValitaded] = useState(false)

  const [days, setDays] = useState({
    RoleId: 0,
    OffDays: OffDays,
  });



  const getRoles = () => {
    simpleGetCallWithErrorResponse(ApiConfig.ROLES_LIST)
      .then((res) => {
        if (res?.json?.Success) {
          setRoles(res?.json?.Data);
        } else {
          notifyError(res?.json.Message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getRoles();
  }, []);

  const getSettingById = (roleId) => {
    simpleGetCallWithErrorResponse(
      ApiConfig.GET_CALENDER_SETTING_BY_ROLE + roleId
    )
      .then((res) => {
        if (res?.json?.Success) {
          if (res?.json?.Data?.length > 0) {
            setDays({
              RoleId: Number(roleId),
              OffDays: res?.json?.Data,
            });
          } else {
            setDays({
              RoleId: Number(roleId),
              OffDays: OffDays,
            });
          }
        } else {
          notifyError(res?.json?.Message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changeWeekStatus = (index, week, checked) => {
    days.OffDays[index][week] = checked;



    setDays((prev) => ({
      ...prev,
      OffDays: days.OffDays,
    }));
  };

  const handleWorkingTime = (index, shift) => {
    days.OffDays[index].WorkDayType = shift;

    if (shift == '3') {
      days.OffDays[index].Week1 = true
      days.OffDays[index].Week2 = true
      days.OffDays[index].Week3 = true
      days.OffDays[index].Week5 = true
      days.OffDays[index].Week4 = true
      days.OffDays[index].Week6 = true
    }



    setDays((prev) => ({
      ...prev,
      OffDays: days.OffDays,
    }));
  };

  const submitSetting = () => {
    if (days.RoleId === 0) {
      notifyError("Please Select Role");
      return;
    }

    let _isValid = days.OffDays.every((i, index) => i.WorkDayType != 0)

    if (!_isValid) {

      setIsValitaded(true)

      return

    }

    PostCallWithErrorResponse(
      ApiConfig?.CALENDAR_SETTING_ADD,
      JSON.stringify(days)
    ).then((res) => {
      if (res?.json?.Success) {
        notifySuccess(res?.json?.Message);
      } else {
        notifyError(res?.json?.Message);
      }
    });
  };

  const { sidebar, setSidebar, Dark, setDark } = useContext(AppContext);
  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content">
          <div className="sub-header-role ">
            <h6 className="mt-2">Shift Settings</h6>
          </div>
          <div className="d-flex justify-content-between role-searchbar-and-btns RspSalary">
            <div className="role-table-header accoridance">
              <div className="search-input-wrapper allAcordiance">
                {/* {permissions && permissions["View All Announcement"] && ( */}
                <Link to="/ShiftMaster">
                  <button className=" my-anc-btn-sub-header  ">
                    Shift Time
                  </button>
                </Link>
                {/* )} */}
              </div>
              <div className="entries-wrapper myAccordiance">
                {/* {permissions && permissions["View My Announcement"] && ( */}
                <Link to="/CalendarSettings">
                  <button className="active all-anc-btn-sub-header ">
                    Shift Settings
                  </button>
                </Link>
                {/* )} */}
              </div>

            </div>
          </div>
          <div className="innerRoleSec">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Application For
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    value={days?.RoleId}
                    onChange={(e) => {
                      days.RoleId = Number(e.target.value);
                      setDays(days);
                      setUpdate(!update);
                      getSettingById(e.target.value);
                    }}
                  >
                    <option disabled value="0">
                      Select Role
                    </option>
                    {roles.map((role, index) => {
                      return <option value={role?.RoleId}>{role?.Name}</option>;
                    })}
                  </select>
                </div>
              </div>
              <div>
                <label
                  htmlFor=""
                  className="enter-role-text"
                  style={{ fontSize: "18px" }}
                >
                  Work Week
                </label>
              </div>
              <br />
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Monday
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    // value={days?.OffDays[0].WorkDayType}
                    value={days?.OffDays[0]?.WorkDayType}
                    onChange={(e) => {
                      handleWorkingTime(0, Number(e.target.value));
                      setUpdate(!update);
                    }}
                  >
                    <option disabled value={"0"}>
                      Select
                    </option>
                    <option value="1">Full Day</option>

                    <option value="2">Half Day</option>
                    <option value="3">Non-working Day</option>
                  </select>
                  <div className="text-danger">{isvalitaded && days?.OffDays[0]?.WorkDayType == 0 && 'Please Select Work Type'}</div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Tuesday
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    value={days?.OffDays[1]?.WorkDayType}
                    onChange={(e) => {
                      handleWorkingTime(1, Number(e.target.value));
                      setUpdate(!update);
                    }}
                  >
                    <option disabled value={"0"}>
                      Select
                    </option>
                    <option value="1">Full Day</option>

                    <option value="2">Half Day</option>
                    <option value="3">Non-working Day</option>
                  </select>
                  <div className="text-danger">{isvalitaded && days?.OffDays[1]?.WorkDayType == 0 && 'Please Select Work Type'}</div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Wednesday
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    value={days?.OffDays[2]?.WorkDayType}
                    onChange={(e) => {
                      handleWorkingTime(2, Number(e.target.value));
                      setUpdate(!update);
                    }}
                  >
                    <option disabled value={"0"}>
                      Select
                    </option>
                    <option value="1">Full Day</option>

                    <option value="2">Half Day</option>
                    <option value="3">Non-working Day</option>
                  </select>
                  <div className="text-danger">{isvalitaded && days?.OffDays[2]?.WorkDayType == 0 && 'Please Select Work Type'}</div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Thursday
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    value={days?.OffDays[3]?.WorkDayType}
                    onChange={(e) => {
                      handleWorkingTime(3, Number(e.target.value));
                      setUpdate(!update);
                    }}
                  >
                    <option disabled value={"0"}>
                      Select
                    </option>
                    <option value="1">Full Day</option>

                    <option value="2">Half Day</option>
                    <option value="3">Non-working Day</option>
                  </select>
                  <div className="text-danger">{isvalitaded && days?.OffDays[3]?.WorkDayType == 0 && 'Please Select Work Type'}</div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Friday
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    value={days?.OffDays[4]?.WorkDayType}
                    onChange={(e) => {
                      handleWorkingTime(4, Number(e.target.value));
                      setUpdate(!update);
                    }}
                  >
                    <option disabled value={"0"}>
                      Select
                    </option>
                    <option value="1">Full Day</option>

                    <option value="2">Half Day</option>
                    <option value="3">Non-working Day</option>
                  </select>
                  <div className="text-danger">{isvalitaded && days?.OffDays[4]?.WorkDayType == 0 && 'Please Select Work Type'}</div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Saturday
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    value={days?.OffDays[5]?.WorkDayType}
                    onChange={(e) => {
                      handleWorkingTime(5, Number(e.target.value));
                      setUpdate(!update);
                    }}
                  >
                    <option disabled value={"0"}>
                      Select
                    </option>
                    <option value="1">Full Day</option>

                    <option value="2">Half Day</option>
                    <option value="3">Non-working Day</option>
                  </select>
                  <div className="text-danger">{isvalitaded && days?.OffDays[5]?.WorkDayType == 0 && 'Please Select Work Type'}</div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12">
                <div className="mb-4">
                  <label htmlFor="" className="enter-role-text">
                    Sunday
                  </label>
                  <select
                    class="form-select tasKCategory1 select-drop-icon"
                    aria-label="Default select example"
                    value={days?.OffDays[6]?.WorkDayType}
                    onChange={(e) => {
                      handleWorkingTime(6, Number(e.target.value));
                      setUpdate(!update);
                    }}
                  >
                    <option disabled value={"0"}>
                      Select
                    </option>
                    <option value="1">Full Day</option>

                    <option value="2">Half Day</option>
                    <option value="3">Non-working Day</option>
                  </select>
                  <div className="text-danger">{isvalitaded && days?.OffDays[6]?.WorkDayType == 0 && 'Please Select Work Type'}</div>
                </div>
              </div>
            </div>
            <div>
              <label
                htmlFor=""
                className="enter-role-text"
                style={{ fontSize: "18px" }}
              >
                Week Definition
              </label>
            </div>
            <br />
            <div className=" d-flex justify-content-center">
              <div className="container">
                {days.OffDays.map((day, index) => (

                  <div className="form-group d-flex row" key={index}>
                    <div className="col-sm-2 control-label align-items-center">
                      <label htmlFor="" className="enter-role-text">
                        {day?.OffDay}:
                      </label>
                    </div>
                    <div className="col-sm-9">
                      <p id={`wd${day.OffDay.toLowerCase()}`}>
                        {[1, 2, 3, 4, 5, 6].map((week) => (
                          <label
                            htmlFor=""
                            className="enter-role-text"
                            key={week}
                          >
                            <input
                              className={`chk${day.OffDay.toLowerCase()} mx-3`}
                              type="checkbox"
                              disabled={day?.WorkDayType == '3'}
                              name={`${day}Week${week}`}
                              checked={day["Week" + week]}
                              //defaultChecked={day["Week" + week]}
                              onChange={(e) =>
                                changeWeekStatus(
                                  index,
                                  "Week" + week,
                                  e.target.checked
                                )
                              }
                            />
                            {`${week}${week === 1 ? "st" : week === 2 ? "nd" : week === 3 ? "rd" : "th"} week`}
                          </label>
                        ))}
                      </p>
                      &nbsp;
                    </div>
                  </div>
                ))}
                {/* <pre>{JSON.stringify(checkedItems, null, 2)}</pre> */}
              </div>
            </div>
            <div>
              <img src={Warning} className="mx-2 " alt="" />
              <label
                htmlFor=""
                className="enter-role-text"
                style={{
                  fontSize: "14px",
                  color: "var(--blue_53B7E8_LightMode)",
                }}
              >
                Selected weeks will be considered off days/non-working days.
              </label>
            </div>
            <div className="col-md-12 text-end mt-2">
              <button className="impButton" onClick={submitSetting}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CalendarSettings;
